import apiClient from '../client';
import type { Transportation, CreateTransportationPayload, UpdateTransportationPayload } from '@/types';

export const transportationApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: Transportation[] }>('/transportation', { params }).then((r) => r.data.data),

  getById: (id: number) =>
    apiClient.get<{ data: Transportation }>(`/transportation/${id}`).then((r) => r.data.data),

  create: (payload: CreateTransportationPayload) =>
    apiClient.post<{ data: Transportation }>('/transportation', payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateTransportationPayload) =>
    apiClient.put<{ data: Transportation }>(`/transportation/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`/transportation/${id}`),
};

